import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { AppProvider, useApp } from './state/AppProvider';
import { useLang } from './i18n';
import { TopBar } from './components/TopBar';
import { PathGraph } from './components/graph/PathGraph';
import { Panel } from './components/panel/Panel';
import { AboutModal } from './components/AboutModal';
import { Toast } from './components/Toast';
import { LiveRegion } from './components/LiveRegion';

export default function App() {
  return (
    <AppProvider>
      <Shell />
    </AppProvider>
  );
}

function Shell() {
  const { sel } = useApp();
  const lang = useLang();
  const { t } = useTranslation();

  /* The document follows the interface language, including its title. */
  useEffect(() => {
    document.documentElement.lang = lang;
    document.title = t('docTitle');
  }, [lang, t]);

  return (
    <>
      <TopBar />
      <main className="stage" id="stage" data-view={sel ? 'lesson' : 'overview'}>
        <PathGraph />
        <Panel />
      </main>
      <AboutModal />
      <Toast />
      <LiveRegion />
    </>
  );
}
